/** @format */

/**
 *  check if object is empty
 */
const hasValues = (obj: any) => Object.keys(obj).length === 0;

export { hasValues };
